(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-roundels"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.roundels-carousel-arrow');
    if (!button || button.disabled) return;

    const grid = button
      .closest('.section-collection-roundels__carousel-wrapper')
      ?.querySelector('.section-collection-roundels__grid');
    if (!grid) return;

    const cards = grid.querySelectorAll(':scope > .roundel-card');
    if (cards.length < 2) return;

    const step = cards[1].offsetLeft - cards[0].offsetLeft;
    const direction = button.classList.contains('roundels-carousel-arrow--prev') ? -1 : 1;

    grid.scrollBy({ left: direction * step, behavior: 'smooth' });
  });

  function updateRoundelsCarouselArrows(grid) {
    const wrapper = grid.closest('.section-collection-roundels__carousel-wrapper');
    const prev = wrapper?.querySelector('.roundels-carousel-arrow--prev');
    const next = wrapper?.querySelector('.roundels-carousel-arrow--next');
    if (!prev || !next) return;

    const maxScroll = grid.scrollWidth - grid.clientWidth;
    prev.disabled = grid.scrollLeft <= 1;
    next.disabled = grid.scrollLeft >= maxScroll - 1;
  }

  document.querySelectorAll('.section-collection-roundels__grid--carousel-desktop').forEach((grid) => {
    updateRoundelsCarouselArrows(grid);
    grid.addEventListener('scroll', () => updateRoundelsCarouselArrows(grid), { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
